<button class="menu-trigger" (click)="toggleMenu.emit()">
  <mat-icon>menu</mat-icon>
  <span>Menú</span>
</button>
<a [routerLink]="['/dashboard']">
  <img class="logo" src="/assets/images/logo/duoges.png" alt="BodyCult" />
</a>
<ng-container>
  <button class="profile" [matMenuTriggerFor]="menu">
    <img [src]="vm.avatar()" alt="Usuario" />
    <mat-icon class="status-icon" [color]="vm.badgeColor()">
      {{ vm.offlineIsActivated() ? 'wifi_off' : 'wifi' }}
    </mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <div class="menu-header">
      <p class="options">Menu de usuario</p>
      <ng-container *ngIf="vm.profile() as profile">
        <p>{{ profile.firstname }} {{ profile.lastname }}</p>
        <p>{{ profile.email }}</p>
      </ng-container>
    </div>
    <button
      mat-menu-item
      (click)="toggleOffline()"
      *ngIf="hasOfflineCapabilities && vm.offlineIsActivated()"
    >
      <mat-icon>wifi</mat-icon>
      <span>Modo online</span>
    </button>
    <button
      mat-menu-item
      (click)="toggleOffline()"
      *ngIf="hasOfflineCapabilities && !vm.offlineIsActivated()"
    >
      <mat-icon>wifi_off</mat-icon>
      <span>Modo offline</span>
    </button>
    <a
      mat-menu-item
      [routerLink]="['/dashboard', 'profile']"
      [appDisabled]="vm.offlineIsActivated()"
    >
      <mat-icon>account_circle</mat-icon>
      <span>Mi perfil</span>
    </a>
    <button mat-menu-item (click)="logOut()" [disabled]="vm.offlineIsActivated()">
      <mat-icon>logout</mat-icon>
      <span>Cerrar sesión</span>
    </button>
  </mat-menu>
</ng-container>
